export enum WidgetSize {
  Small,
  Large
}
